import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSession } from '@/lib/auth-client'
import { getLocalizedPath } from '@/i18n/routes'
import type { SupportedLanguage } from '@/i18n'

/** Mostra `children` solo a un utente autenticato e abilitato; altrimenti rimanda al login. */
export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { data, isPending } = useSession()
  const { i18n } = useTranslation()
  const location = useLocation()

  if (isPending) {
    return <main className="min-h-screen bg-paper" aria-busy="true" />
  }
  if (!data?.user.enabled) {
    const login = getLocalizedPath('login', i18n.language as SupportedLanguage)
    return <Navigate to={login} replace state={{ from: location.pathname }} />
  }
  return <>{children}</>
}
